function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "linear-gradient",
  x1: 28.54,
  y1: 35.57,
  x2: 11.41,
  y2: 65.24,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  offset: 0,
  stopColor: "#0052cc"
}), React.createElement("stop", {
  offset: 0.92,
  stopColor: "#2684ff"
})));

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "Atlassian-horizontal-blue-rgb");

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, React.createElement("g", {
  id: "Blue"
}, React.createElement("path", {
  className: "cls-1",
  d: "M19.64,30.56a1.88,1.88,0,0,0-3.2.35L.21,63.36a1.94,1.94,0,0,0,1.74,2.81h22.6a1.87,1.87,0,0,0,1.74-1.07C31.15,55,28.2,39.7,19.64,30.56Z"
}), React.createElement("path", {
  className: "cls-2",
  d: "M31.55,1A42.81,42.81,0,0,0,29,43.3L39.95,65.1a1.94,1.94,0,0,0,1.74,1.07h22.6A1.94,1.94,0,0,0,66,63.36L34.85,1A1.83,1.83,0,0,0,31.55,1Z"
}), React.createElement("path", {
  className: "cls-3",
  d: "M296.64,27.06c0,8,3.73,14.42,18.31,17.23,8.7,1.82,10.52,3.23,10.52,6.13s-1.82,4.64-8,4.64a44.89,44.89,0,0,1-21.13-5.72V62.44c4.39,2.15,10.19,4.56,21,4.56,15.25,0,21.3-6.79,21.3-16.9m0,0c0-9.53-5.05-14-19.31-17.07-7.87-1.74-9.78-3.48-9.78-6,0-3.15,2.82-4.47,8-4.47,6.3,0,12.51,1.91,18.4,4.56V14.63a41.58,41.58,0,0,0-18-3.73c-14.09,0-21.38,6.13-21.38,16.16"
}), React.createElement("polygon", {
  className: "cls-3",
  points: "492.52 11.73 492.52 66.17 504.12 66.17 504.12 24.66 509.01 35.68 525.42 66.17 540 66.17 540 11.73 528.4 11.73 528.4 46.87 524.01 36.67 510.83 11.73 492.52 11.73"
}), React.createElement("rect", {
  className: "cls-3",
  x: 406.06,
  y: 11.73,
  width: 12.68,
  height: 54.44
}), React.createElement("path", {
  className: "cls-3",
  d: "M391.43,50.1c0-9.53-5.05-14-19.31-17.07-7.87-1.74-9.78-3.48-9.78-6,0-3.15,2.82-4.47,8-4.47,6.3,0,12.51,1.91,18.4,4.56V14.63a41.58,41.58,0,0,0-18-3.73c-14.09,0-21.38,6.13-21.38,16.16,0,8,3.73,14.42,18.31,17.23,8.7,1.82,10.52,3.23,10.52,6.13s-1.82,4.64-8,4.64a44.89,44.89,0,0,1-21.13-5.72V62.44c4.39,2.15,10.19,4.56,21,4.56,15.25,0,21.3-6.79,21.3-16.9"
}), React.createElement("polygon", {
  className: "cls-3",
  points: "198.16 11.73 198.16 66.17 224.22 66.17 228.32 54.41 210.92 54.41 210.92 11.73 198.16 11.73"
}), React.createElement("polygon", {
  className: "cls-3",
  points: "146.67 11.73 146.67 23.5 160.76 23.5 160.76 66.17 173.52 66.17 173.52 23.5 188.6 23.5 188.6 11.73 146.67 11.73"
}), React.createElement("path", {
  className: "cls-3",
  d: "M128.17,11.73H111.45l-19,54.44H107L109.66,57A36,36,0,0,0,130,57l2.69,9.17h14.5Zm-8.36,35.46a24.76,24.76,0,0,1-7-1l7-23.77,7,23.77A24.76,24.76,0,0,1,119.81,47.19Z"
}), React.createElement("path", {
  className: "cls-3",
  d: "M269.14,11.73H252.42l-19,54.44h14.5L250.63,57a36,36,0,0,0,20.3,0l2.69,9.17h14.5Zm-8.36,35.46a24.76,24.76,0,0,1-7-1l7-23.77,7,23.77A24.76,24.76,0,0,1,260.78,47.19Z"
}), React.createElement("path", {
  className: "cls-3",
  d: "M464.42,11.73H447.7l-19,54.44h14.5L445.91,57a36,36,0,0,0,20.3,0l2.69,9.17h14.5Zm-8.36,35.46a24.76,24.76,0,0,1-7-1l7-23.77,7,23.77A24.76,24.76,0,0,1,456.06,47.19Z"
})));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 540 67"
  }, props), _ref, _ref2, _ref3);
};

export default __webpack_public_path__ + "static/media/atlassian.29f387bb.svg";
export { SvgComponent as ReactComponent };